import modalActions from "actions/modal";
import Modal from "components/modal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Action, ActionFunctionAny } from "redux-actions";

const mapStateToProps = (state: {
    layout: { fullscreen: boolean; theme: "dark" | "light" };
    modal: { items: {} };
    dictionaries: {
        enums: { [key: string]: { label: string; value: number; options: { id: number; value: [] }[] }[] };
    };
}) => ({
    items: state.modal.items,
    enums: state.dictionaries.enums,
    theme: state.layout.theme,
});

const mapDispatchToProps = (dispatch: ActionFunctionAny<Action<Object>>) => ({
    open: (params: {}) => dispatch(modalActions.open(params)),
    close: () => dispatch(modalActions.close()),
    add: (params: {}) => dispatch(modalActions.add(params)),
    closeAll: () => dispatch(modalActions.closeAll()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modal));
